import React from 'react'
import WrappedStoryDispatchContext from './wrappedStoryDispatchContext'
import WrappedStoryStateContext from './wrappedStoryStateContext'
import type { WrappedStoryDispatchAction, WrappedStoryState } from './wrappedStoryStateReducer'

interface Props {
  state: WrappedStoryState
  dispatch: React.Dispatch<WrappedStoryDispatchAction>
  children: React.ReactNode
}

function WrappedStoryStateProvider({ state, dispatch, children }: Props) {
  return (
    <WrappedStoryStateContext.Provider value={state}>
      <WrappedStoryDispatchContext.Provider value={dispatch}>
        {children}
      </WrappedStoryDispatchContext.Provider>
    </WrappedStoryStateContext.Provider>
  )
}

export default WrappedStoryStateProvider
